import CustomTable from "@UI/CustomTable/CustomTable"
import { useReceivedPaymentDetailTable } from "./hooks/useReceivedPaymentDetailTable"
import ExonerateModal from "./components/ExonerateModal/ExonerateModal"
import ExtraordinaryPaymentModal from "./components/ExtraordinaryPaymentModal/ExtraordinaryPaymentModal"
import UpdateAmountModal from "./components/UpdateAmountModal/UpdateAmountModal"

const ReceivedPaymentDetailBodyTable = () => {
  const {
    loadingCollectionAdministrationTable,
    isOpenReceivedPaymenteModal,
    chargeInstanceTableData,
    columns,
    handleOnOpenCloseModal,
    handleChangeTable
  } = useReceivedPaymentDetailTable()

  return (
    <div>
      <CustomTable
        className="custom-table-variant-1"
        loading={loadingCollectionAdministrationTable}
        dataSource={chargeInstanceTableData.dataTable}
        columns={columns}
        onChange={handleChangeTable}
        pagination={{
          pageSize: chargeInstanceTableData.metadata.limit,
          total: chargeInstanceTableData.metadata.quantity,
          defaulPageSize: chargeInstanceTableData.metadata.limit,
          current: chargeInstanceTableData.currentPage,
          showTotal: (total, range) => `${range[0]}-${range[1]} de ${total}`,
          position: ["bottomRight"]
        }}
      />
      <ExonerateModal
        isOpen={isOpenReceivedPaymenteModal.isOpen && isOpenReceivedPaymenteModal.name === "exonerate"}
        onClose={handleOnOpenCloseModal}
        record={isOpenReceivedPaymenteModal.record}
      />     
      <ExtraordinaryPaymentModal
        isOpen={isOpenReceivedPaymenteModal.isOpen && isOpenReceivedPaymenteModal.name === "extraordinary_payment"}
        onClose={handleOnOpenCloseModal}
        record={isOpenReceivedPaymenteModal.record}
      />
      <UpdateAmountModal
        isOpen={isOpenReceivedPaymenteModal.isOpen && isOpenReceivedPaymenteModal.name === "amount"}
        onClose={handleOnOpenCloseModal}
        record={isOpenReceivedPaymenteModal.record}
      />
    </div>
  )
}

export default ReceivedPaymentDetailBodyTable
